import React from 'react';
import Image from './Image';

const Footer = () => (
	<footer className="flex flex-col justify-center items-center self-stretch px-20 pt-px pb-2 w-full bg-zinc-800 max-md:px-5 max-md:max-w-full">
		<div className="flex justify-center items-center px-16 py-20 max-w-full w-[1120px] max-md:px-5">
			<div className="mb-3.5 max-w-full w-[890px]">
				<div className="flex gap-5 max-md:flex-col max-md:gap-0">
					<div className="flex flex-col w-[52%] max-md:ml-0 max-md:w-full">
						<div className="flex flex-col grow pr-9 pb-1.5 mt-7 text-white max-md:mt-10">
							<div className="flex gap-5 text-4xl font-bold leading-6 whitespace-nowrap">
								<Image src="./assets/billbaordBlue.svg" alt="Billboard logo" className="shrink-0 aspect-square w-[60px]" />
								<div className="flex-auto my-auto">Billboard</div>
							</div>
							<p className="text-lg leading-7 text-zinc-400">
								Join our Discord channel or follow us on<br />
								X to keep up to date with our latest work<br />
								and announcements.
							</p>
							<div className="flex gap-5 justify-between self-start mt-5 whitespace-nowrap leading-[100%]">
								<div className="text-xl"></div>
								<div className="text-2xl"></div>
							</div>
						</div>
					</div>
					<div className="flex flex-col ml-5 w-[24%] max-md:ml-0 max-md:w-full">
						<div className="flex flex-col text-lg leading-6 text-zinc-400 max-md:mt-10">
							<h3 className="text-2xl font-bold tracking-wide leading-7 text-white">Quick Link</h3>
							<div className="mt-3.5">How it works</div>
							<div className="mt-5">About</div>
							<a className="mt-5" href='https://twitter.com/BillboardSolana' target="_blank" rel="noreferrer"><img className="h-7 hover:opacity-50 duration-500" src='./assets/X_logo_2023_original.svg' /></a>
						</div>
					</div>
					<div className="flex flex-col ml-5 w-[24%] max-md:ml-0 max-md:w-full">
						<div className="flex flex-col py-px text-lg leading-6 whitespace-nowrap text-zinc-400 max-md:mt-10">
							<h3 className="text-2xl font-bold tracking-wide leading-7 text-white">Community</h3>
							<div className="mt-5">Documentation</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="mt-3.5 text-base leading-7 text-zinc-400">
			Copyright © 2024 Billboard
		</div>
	</footer>
)

export default Footer;